import { useAppTheme } from "@hooks/useAppTheme";
import type { WorkflowItemEdge } from "@memorang/types/src/session/new-session";
import {
	BaseEdge,
	EdgeLabelRenderer,
	type EdgeProps,
	getSmoothStepPath,
	useReactFlow,
} from "@xyflow/react";
import type { FC } from "react";
import { TextInput } from "react-native";

const CustomEdge: FC<EdgeProps<WorkflowItemEdge>> = ({
	id,
	sourceX,
	sourceY,
	targetX,
	targetY,
	sourcePosition,
	targetPosition,
	markerEnd,
	style,
	label,
	data,
}) => {
	const theme = useAppTheme();
	const { updateEdge } = useReactFlow();

	const [edgePath, labelX, labelY] = getSmoothStepPath({
		sourceX,
		sourceY,
		sourcePosition,
		targetX,
		targetY,
		targetPosition,
	});

	const handleLabelChange = (text: string) => {
		updateEdge(id, { label: text });
	};

	return (
		<>
			<BaseEdge id={id} path={edgePath} markerEnd={markerEnd} style={style} />
			<EdgeLabelRenderer>
				<div
					style={{
						position: "absolute",
						transform: `translate(-50%, -105%) translate(${labelX}px,${labelY}px)`,
						pointerEvents: "all",
					}}
					className="nodrag nopan"
				>
					<TextInput
						editable={data?.correct === undefined}
						value={label?.toString() || ""}
						onChangeText={handleLabelChange}
						placeholder="Add a label"
						placeholderTextColor={theme.colors.outlineVariant}
						style={{
							padding: 4,
							textAlign: "center",
							backgroundColor: "white",
							outline: "none",
							...theme.fonts.labelSmall,
							fontSize: 10,
							color:
								data?.correct === false
									? theme.colors.error
									: theme.colors.onSurface,
						}}
					/>
				</div>
			</EdgeLabelRenderer>
		</>
	);
};

export default CustomEdge;
